import { DefaultTenantConfig, ITenantConfig } from '../domains/tenant-config';
import { RootStore } from './root.store';
import { makeAutoObservable } from 'mobx';

export class TenantStore {
  root: RootStore;

  private _config: ITenantConfig = new DefaultTenantConfig();

  constructor(root: RootStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  get config(): ITenantConfig {
    return this._config;
  }
}
